// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type Note } from '../reusable/Notes'

type NotePatchParam = {
  content: string
}

export function useUpdateNote ({
  noteId,
  memberId,
  employerId,
}: {
  noteId: string
  memberId?: string
  employerId?: string
}) {
  return useMutation<Note, GrapeAPIErrorType, NotePatchParam>({
    mutationFn: async ({ content }) => {
      const request = new FetchRequest(
        'patch',
        `/api/web/brokers/notes/${noteId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            ...(memberId ? { member_id: memberId } : {}),
            ...(employerId ? { employer_id: employerId } : {}),
            content,
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
